export default function PageHeader({ eyebrow, title, subtitle, children }) {
    return (
        <section className="relative overflow-hidden bg-gradient-to-b from-[#1E3A8A] to-[#1E40AF] text-white">
            <div className="absolute inset-0 bg-grid opacity-20"></div>
            <div className="absolute -top-32 -right-32 w-96 h-96 bg-amber-400/20 rounded-full blur-3xl"></div>
            <div className="absolute -bottom-32 -left-32 w-96 h-96 bg-blue-400/20 rounded-full blur-3xl"></div>
            <div className="relative max-w-7xl mx-auto px-6 lg:px-8 py-20 lg:py-24">
                {eyebrow && (
                    <div className="text-xs sm:text-sm font-semibold uppercase tracking-[0.3em] text-amber-300 mb-4">
                        {eyebrow}
                    </div>
                )}
                <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight max-w-4xl">
                    {title}
                </h1>
                {subtitle && (
                    <p className="mt-5 text-base sm:text-lg text-blue-100 max-w-3xl leading-relaxed">{subtitle}</p>
                )}
                {children && <div className="mt-8">{children}</div>}
            </div>
        </section>
    );
}
